import de from '../questionnaires/POC_Menstruation/de'
import fr from '../questionnaires/POC_Menstruation/fr'
import it from '../questionnaires/POC_Menstruation/it'

export default {
  studyName: 'square-study',
  canJoin: false,
  canSeeResults: false,
  header: 'Square Study',
  subheader: 'This is a test study.',
  baselineFormId: 'square-study-identifier', // accessible through study registration, not here
  // baselineQuestionnaire: {},
  recurringFormId: 'square-study-recurring',
  hasMultipleLanguages: true, // unused parameter for now, hardcoded elsewhere
  recurringQuestionnaire: {
    de,
    fr,
    it
  },
  defaultLang: 'de' // unused parameter for now, hardcoded elsewhere
  // TODO:

}



// WEBPACK FOOTER //
// ./src/store/recurring/squareStudy.js